import React, { useState, useEffect, useCallback } from 'react';
import {getLabel} from "../../Utils/labels";

const CgvList = ({ onRefresh, refreshTrigger, credentials }) => {
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchFiles = useCallback(async () => {
        setLoading(true);
        setError(null);

        try {
            const response = await fetch(`${process.env.REACT_APP_SERVER_URI}/api/cgv/list`, {
                headers: {
                    'Authorization': 'Basic ' + window.btoa(`${credentials.username}:${credentials.password}`)
                }
            });

            if (!response.ok) {
                throw new Error('Erreur lors du chargement des fichiers');
            }
            
            const data = await response.json();
            setFiles(data.files || []);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, [credentials.username, credentials.password]);

    useEffect(() => {
        fetchFiles();
    }, [refreshTrigger, fetchFiles]);

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('fr-FR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    if (loading) {
        return <div className="cgv-loading">Chargement des fichiers...</div>;
    }

    if (error) {
        return (
            <div className="cgv-error">
                <p>Erreur: {error}</p>
                <button onClick={fetchFiles} className="retry-btn">Réessayer</button>
            </div>
        );
    }

    return (
        <div className="cgv-list">
            <div className="cgv-list-header">
                <h3>Fichiers CGV ({files.length})</h3>
                <button onClick={fetchFiles} className="refresh-btn">
                    🔄 Actualiser
                </button>
            </div>
            
            {files.length === 0 ? (
                <div className="no-files">
                    <p>Aucun fichier CGV trouvé</p>
                </div>
            ) : (
                <div className="files-table">
                    <div className="table-header">
                        <div className="col-pdf-name">Nom du PDF</div>
                        <div className="col-file-name">Fichier à uploader</div>
                        <div className="col-size">Produits</div>
                        <div className="col-date">Dernière modification</div>
                    </div>
                    
                    {files.map((file, index) => (
                        <div key={index} className="table-row">
                            <div className="col-pdf-name" title={file.displayName}>
                                <span className="file-icon">📄</span>
                                {file.displayName}
                            </div>
                            <div className="col-file-name" title={file.name}>
                                {file.name}
                            </div>
                            <div className="col-size">
                                {file.products.map((product, index) => {
                                    const label = product === "hektor"
                                        ? "Hektor Old"
                                        : getLabel(product);

                                    return (
                                        <React.Fragment key={index}>
                                            {label}<br />
                                        </React.Fragment>
                                    );
                                })}
                            </div>
                            <div className="col-date">{formatDate(file.lastModified)}</div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CgvList; 